module.exports = __webpack_public_path__ + "img/laa_eating_packing_peanuts.decef774.jpg";